// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m2-3";
export var downloadButton = "_m2-4";
export var fileContainer = "_m2-9 _m2-7";
export var fileContainerBase = "_m2-7";
export var fileContainerFixedHeight = "_m2-8 _m2-7";
export var fileInfo = "_m2-5";
export var fileInfoWidthRestricted = "_m2-6";
export var fileType = "_m2-1";
export var fileTypeName = "_m2-2";
export var image = "_m2-0";
export var link = "_m2-b";
export var overflowEllipsis = "_m2-a";